module.exports = __webpack_public_path__ + "img/img-144.2abdcc23.png";